import React, { useCallback } from 'react';
import { AccountType, Privilege } from '../../api';
import styled from 'styled-components';
import { FormControlLabel, Checkbox, Button } from '@material-ui/core';
import _ from 'underscore';
import useHasPrivilege from '../Util/useHasPrivilege';
import SearchField from '../Util/SearchField';

interface Props {
  search?: string | undefined;
  onSearchChange: (val: String) => void;
  types: Array<AccountType>;
  onChangeTypes: any;
  onAddAccount: () => void;
}

const AccountSidemenuFilter: React.FunctionComponent<Props> = (props) => {
  const isAdmin = useHasPrivilege(Privilege.Admin);

  const handleChange = useCallback(
    (type) => (event: any, checked: boolean) => {
      if (checked) {
        props.onChangeTypes([...props.types, type]);
      } else {
        props.onChangeTypes(_.without(props.types, type));
      }
    },
    [props]
  );
  return (
    <Wrapper>
      <SearchField key="search" value={props.search} onChange={props.onSearchChange} />
      <FormControlLabel
        control={
          <Checkbox
            checked={_.contains(props.types, AccountType.Customer)}
            onChange={handleChange(AccountType.Customer)}
            name="customer"
          />
        }
        label="Customers"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={_.contains(props.types, AccountType.Labelling)}
            onChange={handleChange(AccountType.Labelling)}
            name="labelling"
          />
        }
        label="Labelling companies"
      />
      {isAdmin && (
        <Button onClick={props.onAddAccount} variant="outlined" color="primary">
          Add new account
        </Button>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
`;
export default AccountSidemenuFilter;
